import React from "react";
import { motion } from "framer-motion";

export default function Navigation({ activeTab, setActiveTab, isScrolled = false }) {
  const tabs = ["About Me", "Projects", "Expertise", "Tools", "Contact Us"];

  const tabVariants = {
    inactive: { 
      scale: 1,
      color: "#6b7280",
      transition: { duration: 0.2 }
    },
    active: { 
      scale: 1.05,
      color: "#ffffff",
      transition: { duration: 0.2 }
    }
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="flex justify-center px-2 sm:px-4">
      <motion.div 
        className="flex bg-gray-100 rounded-full p-1 relative overflow-x-auto scrollbar-hide max-w-full"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.3 }}
      >
        {tabs.map((tab, index) => (
          <motion.button
            key={tab}
            onClick={() => handleTabClick(tab)}
            className={`relative rounded-full font-medium transition-all duration-200 z-10 whitespace-nowrap ${
              activeTab === tab
                ? "text-white"
                : "text-gray-600 hover:text-gray-900"
            }`}
            variants={tabVariants}
            animate={{
              ...((activeTab === tab ? tabVariants.active : tabVariants.inactive)),
              paddingLeft: isScrolled ? "12px" : "16px",
              paddingRight: isScrolled ? "12px" : "16px",
              paddingTop: isScrolled ? "7px" : "8px",
              paddingBottom: isScrolled ? "7px" : "8px",
              fontSize: isScrolled ? "13px" : "14px"
            }}
            transition={{ duration: 0.5, ease: [0.25, 0.46, 0.45, 0.94] }}
            whileHover={{ 
              scale: activeTab === tab ? 1.05 : 1.02,
              transition: { duration: 0.2 }
            }}
            whileTap={{ scale: 0.95 }}
          >
            {/* Background for active tab */}
            {activeTab === tab && (
              <motion.div
                className="absolute inset-0 bg-black rounded-full shadow-sm"
                layoutId="activeTab"
                transition={{
                  type: "spring",
                  stiffness: 400,
                  damping: 30
                }}
              />
            )}
            
            {/* Tab text */}
            <motion.span 
              className="relative z-10"
              animate={{ 
                color: activeTab === tab ? "#ffffff" : "#6b7280"
              }}
              transition={{ duration: 0.2 }}
            >
              {tab}
            </motion.span>
          </motion.button>
        ))}
      </motion.div>
    </div>
  );
} 